import { Field, getIn } from 'formik';
import React, { FunctionComponent } from 'react';
import Select, { ActionMeta, ControlProps, components } from 'react-select';

import { SearchSelectFieldType } from '../../types';
import { useTranslation } from 'react-i18next';

const SearchSelectField: FunctionComponent<SearchSelectFieldType> = ({
  formikProps,
  options,
  label,
  name,
  disabled,
  required,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <label className={`form-label ${formikProps.touched?.[name] && formikProps.errors?.[name] && 'text-danger'}`}>
        {label}
        {required && <span className="text-danger"> *</span>}
      </label>
      <div className={'input-group'}>
        <Field
          placeholder={`${t('label.selecione')}...`}
          loadingMessage={() => `${t('label.carregando')}...`}
          as={Select}
          className={`search-select__container`}
          name={name}
          menuPlacement={'auto'}
          components={{
            Control: (props: ControlProps<any, false>) => (
              <components.Control
                {...props}
                className={`form-control ${formikProps.touched?.[name] && formikProps.errors?.[name] && 'is-invalid'}`}
              />
            ),
          }}
          options={options}
          disabled={disabled || formikProps.isSubmitting}
          classNamePrefix="search-select"
          value={options ? options.find((option) => option.value === getIn(formikProps.values, name)) : ''}
          onBlur={() => {
            formikProps.setFieldTouched(name, true);
          }}
          isLoading={options?.length < 1}
          onChange={(option: any, action: ActionMeta<any>) => {
            if (action.action === 'clear') {
              formikProps.setFieldValue(name, '');
            } else {
              formikProps.setFieldValue(name, option.value);
            }
          }}
          isClearable
        />
        {formikProps.touched?.[name] && formikProps.errors?.[name] && (
          <div className="invalid-feedback">
            <>{formikProps.errors[name]}</>
          </div>
        )}
      </div>
    </div>
  );
};
export default SearchSelectField;
